/**
 * Tiny dev-only logger. In production these calls are no-ops so we don't
 * leak internal state / URLs to the browser console.
 */
const isDev =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

export const devWarn = isDev ? (...args) => console.warn(...args) : () => {};
export const devError = isDev ? (...args) => console.error(...args) : () => {};
export const devLog = isDev ? (...args) => console.log(...args) : () => {};
